module.exports = __webpack_public_path__ + "static/media/orion_logo.e17bb977.png";